import { Route, Routes } from "react-router-dom";
import AirTreeProjects from 'routes/AirTree';
import AirTreeCreateProject from 'routes/AirTree/createProject';
import AirTreeEditProject from 'routes/AirTree/editProject';
import AirtreePublicProjectList from "routes/AirTree/listPublicProjects";
import AirTreeViewProjectSimulation from "routes/AirTree/viewProjectSimulation";
import SignupForm from 'routes/Auth/signup';
import ForestView from 'routes/ForestView';
import Home from 'routes/Home';
import Profile from "routes/Profile";
import Users from "routes/Users";


const RoutesMap = () => {

    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="signup" element={<SignupForm />} />
            <Route path="profile" element={<Profile />} />
            <Route path="forestview" element={<ForestView />} />
            <Route path="airtree-list" element={<AirTreeProjects />} />
            <Route path="airtree-public-list" element={<AirtreePublicProjectList />} />
            <Route path="airtree-create" element={<AirTreeCreateProject />} />
            <Route path="airtree-modify/:id" element={<AirTreeEditProject />} />
            <Route path="airtree-view/:id" element={<AirTreeViewProjectSimulation />} />
            <Route path="users" element={<Users />} />
        </Routes>
    )
}

export default RoutesMap;




